import { render, staticRenderFns } from "./primary-tabs.vue?vue&type=template&id=1e99f2db&"
import script from "./primary-tabs.vue?vue&type=script&lang=js&"
export * from "./primary-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports